import React from "react";
import { Query } from "react-apollo";
import { Redirect } from "react-router";
import { viewerQuery, ViewerResult } from "../queries";

const requiredRoles = ["ETR Master Admin", "ETR Research Admin"];

export const RedirectIfNotAuthorized: React.FC = ({ children }) => {
  return (
    <Query<ViewerResult> query={viewerQuery}>
      {({ data, error, loading }) => {
        if (error) {
          return <div>Error fetching viewer information.</div>;
        }

        if (loading) {
          return <div>Loading...</div>;
        }

        if (
          !data?.viewer?.id ||
          !data.viewer.roles.some((role) => requiredRoles.includes(role))
        ) {
          return <Redirect to="/" />;
        }
        return children;
      }}
    </Query>
  );
};
